import { CredentialsKeyEnum } from '../types';
export const TWILIO_AUTH_METHODS = ['apiKey'];
/** Credentials of the Twilio authentication method that is not selected. */
export function getUnusedTwilioAuthCredentialKeys(authMethod) {
    return authMethod === 'apiKey'
        ? [CredentialsKeyEnum.Token]
        : [CredentialsKeyEnum.ApiKey, CredentialsKeyEnum.SecretKey];
}
//# sourceMappingURL=twilio-auth-methods.js.map